export default __webpack_public_path__ + "static/media/circle-step-error.034f4801.svg";